import { render, staticRenderFns } from "./AFG.vue?vue&type=template&id=ce6ff5d2&scoped=true&"
import script from "./AFG.vue?vue&type=script&lang=js&"
export * from "./AFG.vue?vue&type=script&lang=js&"
import style0 from "./AFG.vue?vue&type=style&index=0&id=ce6ff5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6ff5d2",
  null
  
)

export default component.exports